<app-theme-toggle></app-theme-toggle>

<!-- Page -->
<!-- Base -->
<div class="flex grow">
	<header app-header
		class="flex lg:hidden items-center fixed z-10 top-0 start-0 end-0 shrink-0 bg-muted h-(--header-height)"
		id="header">
	</header>
	<!-- Wrapper -->
	<div class="flex flex-col lg:flex-row grow pt-(--header-height) lg:pt-0">
		<div app-sidebar
			class="fixed top-0 bottom-0 z-20 hidden lg:flex flex-col items-stretch shrink-0 bg-muted [--kt-drawer-enable:true] lg:[--kt-drawer-enable:false]"
			data-kt-drawer="true" data-kt-drawer-class="kt-drawer kt-drawer-start flex" id="sidebar"
			data-kt-drawer-initialized="true">
		</div>
		<!-- Main -->
		<div
			class="flex flex-col grow rounded-xl bg-background border border-input lg:ms-(--sidebar-width) mt-0 lg:mt-5 m-5">
			<div class="flex flex-col grow kt-scrollable-y-auto lg:[--scrollbar-width:auto] pt-5"
				id="scrollable_content">
				<main class="grow" role="content">
					<div app-toolbar class="pb-5">
					</div>
					<!-- Container -->
					<router-outlet></router-outlet>
					<!-- End of Container -->
				</main>
				<!-- End of Content -->
			</div>
			<footer app-footer class="footer"></footer>
		</div>
	</div>
	<!-- End of Main -->
	<!-- End of Wrapper -->
</div>
<!-- End of Base -->
<!-- End of Page -->